























import { Component, Vue, Prop, Watch, Model } from 'vue-property-decorator';

@Component({
  name: 'ui-input',
})
export default class UiInputComponent extends Vue {
  @Prop({ default: false }) readonly!: boolean;
  @Prop({ default: false }) required!: boolean;
  @Prop({ default: true }) showError!: boolean;
  @Prop({ default: 0 }) minLength!: number;
  @Prop({ default: '' }) placeholder!: string;
  @Prop({ default: '' }) icon!: string;
  @Prop({ default: 'text' }) type!: string;
  @Prop({ default: '' }) label!: string;
  @Model('customInput', { default: '' }) value!: string;
  @Prop({ default: '' }) equal!: string;
  @Prop({ default: false }) transformer!: boolean;
  @Prop({ default: false }) right!: boolean;
  @Prop({ default: false }) autofocus: boolean;
  @Prop({ default: false }) noBorder: boolean;
  @Prop({ default: '' }) height: string;

  //events
  //focus, input, click, onEnter
  mounted() {
    if (this.autofocus) {
      this.$refs.inputEl.focus();
    }
  }
  focused = this.autofocus;

  hasError: boolean = false;
  errorMessage: string = '';
  innerValue = this.value;
  id = `ui_input_${Math.floor(Math.random() * 1000) + 1}`;

  @Watch('focused')
  onChangeFocus() {
    // console.log("focus", this.autofocus, this.focused);
    this.$emit('focus', this.focused);
  }

  @Watch('autofocus')
  getAutofocus() {
    this.focused = this.autofocus;
  }

  @Watch('innerValue')
  onInnerValueChanged(newValue: string) {
    this.isValid();
    if (this.innerValue !== this.value) {
      this.$emit('customInput', this.innerValue);
    }
  }
  @Watch('value')
  onValueChanged(newValue: string) {
    if (this.innerValue !== this.value) {
      this.innerValue = this.value;
    }
  }
  click() {
    this.$emit('click', this.innerValue);
  }
  onEnter() {
    this.$emit('onEnter');
  }
  isValid(): boolean {
    this.errorMessage = '';
    if (this.required && !this.innerValue) {
      this.errorMessage = '*Поле обязательно';
      this.hasError = true;
      return false;
    }
    if (this.minLength && this.innerValue.length < this.minLength) {
      this.errorMessage = `*Минимум ${this.minLength} символов`;
      this.hasError = true;
      return false;
    }
    if (this.equal && this.innerValue !== this.equal) {
      this.errorMessage = `*Значения должны совпадать`;
      this.hasError = true;
      return false;
    }
    if (this.type === 'email') {
      return this.validateEmail();
    }
    this.hasError = false;
    return true;
  }
  validateEmail(): boolean {
    var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    var isValid = re.test(this.innerValue.toLowerCase());
    this.hasError = !isValid;
    if (!isValid) this.errorMessage = '*Не верный формат email';
    return isValid;
  }

  style1 = {
    height: this.height,
    'border-radius': this.borderRadius,
  };
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-input/src/ui-input.vue